module.exports = __webpack_public_path__ + "static/media/third_declension_ua_img.af8a4ad3.JPG";